module.exports = __webpack_public_path__ + "static/media/charcoal.4be22e6a.png";